import { useState } from "react";
import { Radio, Space } from "antd";
import type { RadioChangeEvent } from "antd";
import { showSuccessNotification } from "utilities";
import { AppModal, AppRadioGroup, QuickSettingItem } from "components";
import { useTranslation } from "react-i18next";

export const ProfitProtect = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();

  const [lockPeriod, setLockPeriod] = useState();

  const onChangeLock = (e: RadioChangeEvent) => {
    setValue(3);
    setLockPeriod(e.target.value);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    showSuccessNotification(`Set profit % to ${value}`);
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const [value, setValue] = useState(1);

  const onChange = (e: RadioChangeEvent) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };

  return (
    <>
      <QuickSettingItem
        onClick={() => showModal()}
        buttonText={t("day_target.profit_protect_placeholder")}
        type="button"
      />

      <AppModal
        title={t("day_target.percentage_profit_title")}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <AppRadioGroup onChange={onChange} value={value}>
          <Radio.Button value={50}>
            {t("day_target.percentage_rate.50")}
          </Radio.Button>
          <Radio.Button value={60}>
            {t("day_target.percentage_rate.60")}
          </Radio.Button>
          <Radio.Button value={70}>
            {t("day_target.percentage_rate.70")}
          </Radio.Button>
          <Radio.Button value={80}>
            {t("day_target.percentage_rate.80")}
          </Radio.Button>
          <Radio.Button value={90}>
            {t("day_target.percentage_rate.90")}
          </Radio.Button>
        </AppRadioGroup>

        <div className="d-flex flex-column mt-3">
          <h4 className="mt-4 mb-3">{t("day_target.percentage_sub_title")}</h4>
          <AppRadioGroup onChange={onChange} value={value}>
            <Space direction="vertical">
              <Radio value={1}>{t("day_target.alert_me")}</Radio>
              <Radio value={2}>{t("day_target.square_off_positions")}</Radio>
              <Radio value={3}>{t("day_target.lock_terminal.title")}</Radio>
            </Space>
          </AppRadioGroup>

          <div className="ms-4 mt-2">
            <AppRadioGroup name="sub-option" onChange={onChangeLock}>
              <Radio.Button value={15}>
                {t("day_target.lock_terminal.15_mins")}
              </Radio.Button>
              <Radio.Button value={30}>
                {t("day_target.lock_terminal.30_mins")}
              </Radio.Button>
              <Radio.Button value={60}>
                {t("day_target.lock_terminal.1_hr")}
              </Radio.Button>
              <Radio.Button value={120}>
                {t("day_target.lock_terminal.2_hrs")}
              </Radio.Button>
              <Radio.Button value={240}>
                {t("day_target.lock_terminal.4_hrs")}
              </Radio.Button>
              <Radio.Button value={0}>
                {t("day_target.lock_terminal.full_day")}
              </Radio.Button>
            </AppRadioGroup>
          </div>
        </div>
      </AppModal>
    </>
  );
};
